module.exports = __webpack_public_path__ + "img/Dumbbells.9cc27286.png";